import { Flex } from '@lokalise/louis';

import { DROPZONE_FILE_MAX_SIZE_MB } from '../../constants';
import { DropzoneUploadIcon } from '../../icons';
import { DropzoneColoredText, DropzoneSubtitle, DropzoneTitle } from './style';

export const InitialFilesIdleState = () => (
    <Flex align="center" direction="column" gap={3}>
        <DropzoneUploadIcon />
        <DropzoneTitle>
            <DropzoneColoredText>Choose files</DropzoneColoredText> or simply drag and drop them here
        </DropzoneTitle>
        <DropzoneSubtitle>We support PDF and DOCX files, up to {DROPZONE_FILE_MAX_SIZE_MB} MB each.</DropzoneSubtitle>
    </Flex>
);

export default InitialFilesIdleState;
